import { render } from "./DowngradeToLite.vue?vue&type=template&id=3741a644&scoped=true&ts=true"
import script from "./DowngradeToLite.vue?vue&type=script&lang=ts"
export * from "./DowngradeToLite.vue?vue&type=script&lang=ts"

import "./DowngradeToLite.vue?vue&type=style&index=0&id=3741a644&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3741a644"]])

export default __exports__